import React from 'react';
import { useGrievancePolicy } from "../../Components/DataRetention/GrievancePolicy";
import { getBrandName } from "../../Components/getBrandName";
const GrievancePolicy = () => {
  const { sections, generateContent } = useGrievancePolicy();
  const { brandName,effectiveDate} = getBrandName();

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-heading text-center">
        <h2>Need Help? Here’s How You Can Reach Us</h2>
        <p className="text-muted" style={{fontSize:"0.8rem"}}>Grievance Redressal & Contact Policy</p>
        <p className="text-muted" style={{fontSize:"0.8rem"}}>Effective Date: <strong>{effectiveDate}</strong></p>
      </div>

      <div className="privacy-container">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
        <p>
          At {brandName}, we are committed to transparency, responsibility, and ethical service delivery. If you ever experience issues related to your data, service, or overall platform experience, we want to hear from you.
          This policy outlines how you can raise your concerns and what steps we will take to resolve them, in full compliance with the Digital Personal Data Protection Act, 2023.
          </p>
              {sections.map((section) => (
                <div key={section.id} className="mb-5">
                  <h5 className="fw-bold">{section.title}</h5>
                  <div className="text-muted">
                    {generateContent(section.id)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrievancePolicy;
